// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__ILic4","content":"styles_content__KRpN4","selectAll":"styles_selectAll__34Ann"};